import CIcon from "@coreui/icons-react";
import {
  cilSpeedometer,
  cilGroup,
  cilPuzzle,
  cilSettings,
  cilApplications,
  cilReportSlash,
  cilStar,
  cilBell,
  cilMoney,
  cilCreditCard,
  cilUserPlus,
  cilChart,
  cilShieldAlt,
  cilChatBubble,
} from "@coreui/icons";
import { CNavItem, CNavGroup } from "@coreui/react";
import { dashboard } from "./libs/routes";
import { settings } from "./libs/routes";
import { userMaster } from "./libs/routes";
import { dummyUser } from "./libs/routes";
import { freelancerUser } from "./libs/routes";
import { review } from "./libs/routes";
import { notification } from "./libs/routes";
import { sidebar } from "./constants/translation/common.translation";
import { translation } from "./constants/translation/translation.translation";
import { cms } from "./constants/translation/cms.translation";
import { serviceCategory } from "./constants/translation/serviceCategory.translation";
import { subscriptionPlan } from "./constants/translation/subscriptionPlan.translation";
import { subscribedUser } from "./constants/translation/subscribedUser.translation";
import { referralRecord } from "./constants/translation/referralRecord.translation";
import { communityLeaderboard } from "./constants/translation/communityLeaderboard.translation";
import constants from "./libs/constant";
import { masters } from "./libs/routes";
import { contentModeration, weAllTeam } from "./libs/routes";

const getNavItems = (currentPath, { weAllTeamUnread = 0 } = {}) => {
  const allItems = [
    {
      component: CNavItem,
      name: sidebar.dashboard,
      key: "dashboard",
      href: dashboard,
      icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
      active: currentPath === dashboard,
    },
    {
      component: CNavGroup,
      name: sidebar.userManagement,
      key: "user_management",
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: sidebar.normalUsers,
          key: "normal_users",
          href: userMaster.list,
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            !currentPath?.startsWith(constants.navigation.dummyUserPattern) &&
            !currentPath?.startsWith(
              constants.navigation.freelancerUserPattern,
            ) &&
            (currentPath === userMaster.list ||
              (currentPath?.startsWith(constants.navigation.userViewPattern) &&
                currentPath?.includes(constants.navigation.viewPathKeyword))),
        },
        {
          component: CNavItem,
          name: sidebar.dummyUsers,
          key: "dummy_users",
          href: dummyUser.list,
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active: currentPath?.startsWith(
            constants.navigation.dummyUserPattern,
          ),
        },
        {
          component: CNavItem,
          name: sidebar.freelancerUsers,
          key: "freelancer_users",
          href: freelancerUser.list,
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active: currentPath?.startsWith(
            constants.navigation.freelancerUserPattern,
          ),
        },
      ],
    },
    {
      component: CNavItem,
      name: subscriptionPlan.list.main_heading,
      key: "subscription-plan",
      href: "/masters/subscription-plans/list",
      icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
      active:
        currentPath === "/masters/subscription-plans/list" ||
        currentPath?.startsWith(constants.navigation.subscriptionPlanPattern),
    },
    {
      component: CNavItem,
      name: subscribedUser.list.main_heading,
      key: "subscribed-users",
      href: masters.subscribedUsers.list,
      icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
      active:
        currentPath === masters.subscribedUsers.list ||
        currentPath?.startsWith(constants.navigation.subscribedUserPattern),
    },
    {
      component: CNavItem,
      name: referralRecord.list.main_heading,
      key: "referral-records",
      href: masters.referralRecords.list,
      icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
      active:
        currentPath === masters.referralRecords.list ||
        currentPath?.startsWith(constants.navigation.referralRecordPattern),
    },
    {
      component: CNavItem,
      name: communityLeaderboard.list.main_heading,
      key: "community-leaderboard",
      href: masters.communityLeaderboard.list,
      icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
      active:
        currentPath === masters.communityLeaderboard.list ||
        currentPath?.startsWith(
          constants.navigation.communityLeaderboardPattern,
        ),
    },
    {
      component: CNavGroup,
      name: sidebar.master,
      key: "master",
      icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: translation.list.main_heading,
          key: "translation",
          href: "/masters/translation/list",
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === "/masters/translation/list" ||
            currentPath?.startsWith(constants.navigation.translationPattern),
        },
        {
          component: CNavItem,
          name: "admin.breadcrumb_key_masters_email_template_list",
          key: "email-template",
          href: "/masters/email-templates/list",
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === "/masters/email-templates/list" ||
            currentPath?.startsWith(constants.navigation.emailTemplatePattern),
        },
        {
          component: CNavItem,
          name: "admin.breadcrumb_key_masters_sms_template_list",
          key: "sms-template",
          href: "/masters/sms-templates/list",
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === "/masters/sms-templates/list" ||
            currentPath?.startsWith(constants.navigation.smsTemplatePattern),
        },
        {
          component: CNavItem,
          name: serviceCategory.list.main_heading,
          key: "service-category",
          href: "/masters/service-categories/list",
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === "/masters/service-categories/list" ||
            currentPath?.startsWith(
              constants.navigation.serviceCategoryPattern,
            ),
        },
        {
          component: CNavItem,
          name: cms.list.main_heading,
          key: "cms-master",
          href: "/masters/cms/list",
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === "/masters/cms/list" ||
            currentPath?.startsWith(constants.navigation.cmsPattern),
        },
      ],
    },
    {
      component: CNavItem,
      name: sidebar.reportedUsers,
      key: "reported-users",
      href: masters.reportedUsers.list,
      icon: <CIcon icon={cilReportSlash} customClassName="nav-icon" />,
      active:
        currentPath === masters.reportedUsers.list ||
        currentPath?.startsWith(constants.navigation.reportedUsersPattern) ||
        currentPath === "/masters/report-reasons/list" ||
        currentPath?.startsWith("/masters/report-reasons/"),
    },
    {
      component: CNavItem,
      name: sidebar.reviews,
      key: "reviews",
      href: review.list,
      icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
      active: currentPath?.startsWith(constants.navigation.reviewPattern),
    },
    {
      component: CNavItem,
      name: sidebar.contentModeration,
      key: "content-moderation",
      href: contentModeration.groups.list,
      icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
      active: currentPath?.startsWith(
        constants.navigation.contentModerationPattern,
      ),
    },
    {
      component: CNavItem,
      name: sidebar.weAllTeam,
      key: "weall-team-messages",
      href: weAllTeam.inbox,
      icon: <CIcon icon={cilChatBubble} customClassName="nav-icon" />,
      active: currentPath?.startsWith(constants.navigation.weAllTeamPattern),
      // Live unread count of the WeAll Team inbox (kept current by WeAllTeamRealtime)
      ...(weAllTeamUnread > 0
        ? {
            badge: {
              color: "danger",
              text: weAllTeamUnread > 99 ? "99+" : String(weAllTeamUnread),
            },
          }
        : {}),
    },
    {
      component: CNavItem,
      name: sidebar.notifications,
      key: "notifications",
      href: notification.list,
      icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
      active: currentPath === notification.list,
    },
    {
      component: CNavGroup,
      name: sidebar.settings,
      key: "settings",
      icon: <CIcon icon={cilApplications} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: "admin.tab_key_settings_general_settings",
          key: "general-settings",
          href: settings.general,
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active: currentPath === settings.general,
        },
        {
          component: CNavItem,
          name: "admin.tab_key_settings_rewards_settings",
          key: "rewards-settings",
          href: settings.referral,
          icon: (
            <span className="nav-icon">
              <span className="nav-icon-bullet"></span>
            </span>
          ),
          active:
            currentPath === settings.referral ||
            currentPath === settings.adminRewards,
        },
      ],
    },
  ];

  return allItems;
};

export default getNavItems;
